<div class="choose-security" #secForm>

    <form [class]="'form ' + formClass" [formGroup]="form">
        <!--without security-->
        <div class="items">
            <mat-radio-button checked class="radio-button-new"
                (click)="onSecurityTypeChange(securityTypes.WithoutSecurity)">{{'REQUEST.DEPODIT_WITHOUT_SECURITY' |
                translate}}</mat-radio-button>
            <i class="icon-question-circle-o icon"></i>
        </div>

        <!--time deposit-->
        <div class="items">
            <mat-radio-button class="radio-button-new"
                (click)="onSecurityTypeChange(securityTypes.TimeDeposit)">{{'REQUEST.TIME_DEPODIT_SECURITY' |
                translate}}</mat-radio-button>
            <i class="icon-question-circle-o icon"></i>
        </div>
        <div class="collapsed-div" *ngIf="securityType === securityTypes.TimeDeposit">
            <div class="tc-form-field size-md select-name">
                <label class="label">
                    parichehr :-)
                </label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field has-select-option">
                    <mat-select panelClass="panel-select-option-new">
                        <mat-option value="option1"><span>Option 1</span></mat-option>
                        <mat-option value="option1"><span>Option Three</span></mat-option>
                        <mat-option value="option1"><span>Option Two</span></mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <!--time deposit with secure code-->
        <div class="items">
            <mat-radio-button class="radio-button-new"
                (click)="onSecurityTypeChange(securityTypes.TimeDepositWithSecureCode)">{{'REQUEST.TIME_DEPODIT_WITH_SECURITY_CODE'
                | translate}}</mat-radio-button>
            <i class="icon-question-circle-o icon"></i>
        </div>
        <div class="collapsed-div-code" *ngIf="securityType === securityTypes.TimeDepositWithSecureCode">
            <div class="tc-form-field size-md select-name">
                <label class="label">
                    parichehr :-)
                </label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field has-select-option">
                    <mat-select panelClass="panel-select-option-new">
                        <mat-option value="option1"><span>Option 1</span></mat-option>
                        <mat-option value="option1"><span>Option Three</span></mat-option>
                        <mat-option value="option1"><span>Option Two</span></mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="tc-form-field size-md code">
                <label class="label">
                    Security Code
                </label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field">
                    <input matInput placeholder="ggg">
                    <!-- <mat-icon matSuffix>mode_edit</mat-icon>  -->
                    <i class="icon-question-circle-o icon"></i>
                </mat-form-field>
            </div>
        </div>
    </form>
</div>